module.exports = __webpack_public_path__ + "static/media/flight_not_available_anymore.75eb6732.png";